import {
  GET_PCMODULES_CATALOG,
  GET_PCMODULES_CATALOG_SUCCESS,
  GET_PCMODULES_CATALOG_ERROR,
} from '../../../constants/constantsRed';

export const getPcModulesCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case GET_PCMODULES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_PCMODULES_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_PCMODULES_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
